@if (generalInformation(); as generalInformation) {
  <div class="vehicle-cell">
    <onyx-icon
      [name]="`${generalInformation.category}-filled`"
      [size]="24"
    ></onyx-icon>

    {{ generalInformation | fleetIdentifier }}
  </div>
} @else {
  -
}
